import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-card-info',
  styleUrls: ['./card-info.component.scss'],
  templateUrl: './card-info.component.html',
})
export class CardInfoComponent {
  @Input() value?: number | string;
  @Input() label?: string;
}
